import { useContext, useEffect, useState } from 'react';
import { TestingHqContext } from '../../context/TestingHqContext';
import { get_testing_place_list, upsert_testing_place } from '../../utils/restapi';
import './paper_join.css';
import { formatHandphone } from '../../utils/common';

const TestingPaperJoin = ({ testingScheduleObj, onClose }) => {
  const { testingHqs } = useContext(TestingHqContext);

  // 선택상자 목록들
  const [testingPlaceObj, setTestingPlaceObj] = useState(null);

  // 고사장선택 목록
  const [testingPlaces, setTestingPlaces] = useState([]);

  // 고사장에 대한 데이터 가져오기
  const getTestingPlaces = async () => {
    console.log(`getTestingPlaces called`);

    if (testingScheduleObj.testing_id === undefined) {
      setTestingPlaces([]);
      return;
    }

    const json = {
      testing_id: testingScheduleObj.testing_id,
      hcodes: testingHqs.map(hq => hq.code).join(',')
    };

    console.log("getTestingPlace params:", json);

    try {
      const response = await get_testing_place_list(json);
      console.log("getTestingPlaces:", response);
      setTestingPlaces(response.lists || []);
    } catch (error) {
      console.error("Error fetching place:", error);
      setTestingPlaces([]);
    }
  };

  const handleTestingPlaceChange = async (e) => {
    console.log("handleTestingPlaceChange:", e.target.value);
    const selectedId = Number(e.target.value);
    if (!selectedId) {
      setTestingPlaceObj(null);
      return;
    }
    const selectedPlace = testingPlaces.find(place => place.testing_place_id === selectedId);
    setTestingPlaceObj(selectedPlace || null);
  };

  const handleSave = async () => {
    console.log("handleSave:", testingPlaceObj);
    try {
      const json = testingPlaceObj;
      const response = await upsert_testing_place(json);
      console.log("Save response:", response);
      // 저장 로직 추가
      alert('저장되었습니다.');
    } catch (error) {
      console.error("Error saving data:", error);
      alert('저장 중 오류가 발생했습니다.');
    }
    // ...
    onClose();
  };

  useEffect(() => {
    getTestingPlaces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingHqs.length]);
  
  return (
    <div id="testing_paper_join">
      <div className="head">
        <h1>시험지 수령 보고</h1>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>시험</label>
            <span>
              {testingScheduleObj?.testingObj?.typeName}
              {testingScheduleObj?.testingObj?.title}
              ({testingScheduleObj?.testStartDate} ~ {testingScheduleObj?.testStopDate})
            </span>
          </li>
          <li>
            <label>고사장</label>
            <span>
              <select
                value={testingPlaceObj?.testing_place_id ?? ''}
                onChange={handleTestingPlaceChange}
              >
                <option value="">▒ 선택 ▒</option>
                {testingPlaces.map(place => (
                  <option key={place.testing_place_id} value={place.testing_place_id}>
                    {place.name}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>응시자수</label>
            <span>
              { testingPlaceObj?.accept_users ?? 0 }명
            </span>
          </li>
          <li>
            <label>박스수</label>
            <span>
              <input type="number" min="0" value={testingPlaceObj?.boxes ?? 0} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, boxes: e.target.value })} />박스
            </span>
          </li>
          <li>
            <label>시험지수</label>
            <span>
              <input type="number" min="0" value={testingPlaceObj?.papers ?? 0} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, papers: e.target.value })} />장
            </span>
          </li>
          <li>
            <label>답안지수</label>
            <span>
              <input type="number" min="0" value={testingPlaceObj?.answersheets ?? 0} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, answersheets: e.target.value })} />장
            </span>
          </li>
          <li>
            <label>기타물품</label>
            <span>
              <input type="text" value={testingPlaceObj?.data?.etc ?? ''} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, etc: e.target.value } })} />
            </span>
          </li>
          <li>
            <label>운송책임자 성명</label>
            <span>
              <input type="text" value={testingPlaceObj?.data?.manager?.name ?? ''} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, manager: { ...testingPlaceObj.data.manager, name: e.target.value } } })} />
            </span>
          </li>
          <li>
            <label>운송책임자 핸드폰</label>
            <span>
              <input type="text" pattern="[0-9]{3}-[0-9]{3,4}-[0-9]{4}" maxLength={13} value={testingPlaceObj?.data?.manager?.handphone ?? ''} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, manager: { ...testingPlaceObj.data.manager, handphone: formatHandphone(e.target.value) } } })} />
            </span>
          </li>
          <li>
            <label>인수인계자 성명</label>
            <span>
              <input type="text" value={testingPlaceObj?.data?.receiver?.name ?? ''} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, receiver: { ...testingPlaceObj.data.receiver, name: e.target.value } } })} />
            </span>
          </li>
          <li>
            <label>인수인계자 핸드폰</label>
            <span>
              <input type="text" pattern="[0-9]{3}-[0-9]{3,4}-[0-9]{4}" maxLength={13} value={testingPlaceObj?.data?.receiver?.handphone ?? ''} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, receiver: { ...testingPlaceObj.data.receiver, handphone: formatHandphone(e.target.value) } } })} />
            </span>
          </li>
        </ul>
      </div>
      <div className="foot">
        <button onClick={handleSave}>저장</button>
        <button onClick={() => onClose()}>닫기</button>
      </div>
    </div>
  );
};

export default TestingPaperJoin;